import { TranslateOptionsBase } from '../types/animations';
import { gsap } from 'gsap';
import { TimelineExt, TimelineWithPosition } from '../utils/combine';

export function createIdle(options?: TranslateOptionsBase): gsap.core.Timeline;
export function createIdle(options: TranslateOptionsBase, position: gsap.Position): TimelineWithPosition;
export function createIdle(options?: TranslateOptionsBase, position?: gsap.Position): TimelineExt {
    const { tl: existingTl, vars, timelineVars } = options || { };
    const tl = existingTl || gsap.timeline(timelineVars);
    tl.fromTo({ }, { }, { ...vars });

    if (position !== undefined) {
        return { tl, position };
    }

    return tl;
}
